<h2 mat-dialog-title>New model</h2>
<mat-dialog-content [style.width]="'350px'">
    <form class="cm-new-item-form">
        <cm-organization-select
            [updateOrganization]="updateOrganization.bind(this)"
            [organizationId]="$data().organizationId ?? null"
            [showIfViewedByOwner]="false"
            [showLabel]="false"
            [usedInAddEntityContext]="true"
            cm-sidebar
        ></cm-organization-select>
        <mat-form-field appearance="fill">
            <input matInput placeholder="Name" [(ngModel)]="$name" name="name" />
        </mat-form-field>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-button color="accent" (click)="confirmCreate()" [disabled]="!$canConfirmCreate()">Create</button>
</mat-dialog-actions>
